import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = {
  key: 0,
  class: "section"
}
const _hoisted_4 = { class: "section-content" }
const _hoisted_5 = {
  key: 1,
  class: "report-chart"
}
const _hoisted_6 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_KeyStats = _resolveComponent("KeyStats")!
  const _component_ScoreDistChart = _resolveComponent("ScoreDistChart")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_KeyStats, {
            class: "mt-4",
            data: _ctx.metrics,
            type: (_ctx.iavData && 'vfm') || '',
            valueSign: _ctx.metrics.stat3_sign,
            tooltipVisibility: false
          }, null, 8, ["data", "type", "valueSign"])
        ]),
        (_ctx.filters.awDist)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-title" }, [
                _createElementVNode("div", { class: "section-badge" }),
                _createTextVNode(" AgeWage Score Distribution ")
              ], -1)),
              _createElementVNode("div", _hoisted_4, " The AgeWage score is calculated by comparing the Actual Internal Rate of Return (IRR) of individual savers with the Benchmark IRRs, generated by investing in the AgeWage benchmark fund prepared in collaboration with Hymans Robertson. The AgeWage Score distribution below shows the number of pots in various score ranges. The average AgeWage score for " + _toDisplayString(_ctx.chartData.saversCount) + " Savers is " + _toDisplayString(_ctx.metrics.stat1_title.toFixed(0)) + ". ", 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData && _ctx.filters.awDist)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.scoresData)
                ? (_openBlock(), _createBlock(_component_ScoreDistChart, {
                    key: 0,
                    "data-testid": "ScoreDistChart",
                    chartData: _ctx.scoresData,
                    barColor: _ctx.barColor,
                    provider: _ctx.filters.provider,
                    priceTrack: _ctx.filters.priceTrackObject,
                    isSampleReport: _ctx.isSampleReport,
                    reportfilterRanges: _ctx.reportfilterRanges
                  }, null, 8, ["chartData", "barColor", "provider", "priceTrack", "isSampleReport", "reportfilterRanges"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}